export default __webpack_public_path__ + "static/media/fit-all-sizes.784c8ac1.svg";